export enum ID_CLAIMS_KEYS {
    EMAIL = 'http://realworld-one.com/email',
    USER_ID = 'http://realworld-one.com/userid',
    USERNAME = 'http://realworld-one.com/username',
    ROLE = 'http://realworld-one.com/role',
    FORENAME = 'http://realworld-one.com/forename',
    SURNAME = 'http://realworld-one.com/surname',
    JOB_TITLE = 'http://realworld-one.com/jobtitle',
    PROFILE_PICTURE_URL = 'http://realworld-one.com/picture',
    LOCALE = 'http://realworld-one.com/locale',
    USER_TYPE = 'http://realworld-one.com/usertype',

    COMPANY_ID = 'http://realworld-one.com/companyid',
    COMPANY_NAME = 'http://realworld-one.com/companyname',
    SSO_DOMAINS = 'http://realworld-one.com/ssodomains',
    NAME_ID = 'http://realworld-one.com/nameId',
}
